import { httpRequest } from '../../shared/lib/utils/httpClient';
import { type ActivateConsultResponse } from './caseManagerServices';

export interface AbandonedOrCancelResponse {
  consultId: number;
  patientName: string;
  patientFirstName: string;
  patientLastName: string;
  sessionId: string;
  consultAssignedToProviderId: number;
  isErrorPage: boolean;
  errorType: 'abandoned' | 'missed_call';
  isHidePhiAfterCompletion: boolean;
}

export const getAbandonedOrCancelConsult = async (
  consultId: number
): Promise<AbandonedOrCancelResponse> => {
  const response = await httpRequest<AbandonedOrCancelResponse>({
    method: 'GET',
    url: `/facility/facility-user/${consultId}/abandoned-or-cancel`,
  });
  return response;
};

export const reSubmitAbandonedOrCancelConsult = async (
  userId: string,
  consultId: number
) => {
  const response = await httpRequest<ActivateConsultResponse>({
    method: 'POST',
    url: `/facility/facility-user/${consultId}/resubmit`,
    withCredentials: true,
    headers: { userId },
  });
  return response;
};

export const updateFlagAbandonedOrCancelConsult = async (
  userId: string,
  consultId: number,
  action: string
) => {
  const response = await httpRequest<ActivateConsultResponse>({
    method: 'POST',
    url: `/facility/facility-user/${consultId}/reset-host-ended-flag`,
    params: { action },
    withCredentials: true,
    headers: { userId },
  });
  return response;
};
